/**
 * 弹窗类型枚举
 */
export enum GuideModalType {
  LOGIN_GUIDE = "login_guide",
  AGENT_GUIDE = "agent_guide",
  MEMBER_TIP = "member_tip",
  PRICING_GUIDE = "pricing_guide",
  ACTIVITY_GUIDE = "activity_guide",
}

/**
 * 通用弹窗状态接口
 */
export interface GuideModalState {
  /** 是否已关闭 */
  dismissed: boolean;
  /** 关闭时的时间戳 */
  dismissedAt: number;
  /** 持续时间（分钟） */
  dismissDuration: number;
  /** 会话ID */
  sessionId: string;
  /** 弹窗类型 */
  modalType: GuideModalType;
}

/**
 * 通用弹窗配置接口
 */
export interface GuideModalConfig {
  /** 持续时间（分钟） */
  dismissDuration: number;
  /** 目标页面路径 */
  targetPages: string[];
  /** 是否启用时间控制 */
  enableTimeControl: boolean;
  /** 弹窗类型 */
  modalType: GuideModalType;
  /** 倒计时持续时间（小时） */
  countdownDuration?: number;
  /** 排除页面路径（仅用于非会员引导弹窗） */
  excludedPages?: string[];
}

/**
 * 默认配置
 */
export const DEFAULT_GUIDE_MODAL_CONFIG: GuideModalConfig = {
  dismissDuration: 30, // 30分钟
  targetPages: [], // 空数组，由使用组件的地方传递具体配置
  enableTimeControl: false,
  modalType: GuideModalType.LOGIN_GUIDE,
};

/**
 * 存储键生成器
 */
export const getStorageKey = (modalType: GuideModalType): string => {
  return `${modalType}_state`;
};

/**
 * 会话相关存储键
 */
export const SESSION_ID_KEY = "current_session_id";
export const LAST_SESSION_ID_KEY = "last_session_id";
